export class SiretInputComponent {
  public static attach(inputElement: HTMLInputElement, counterElementId: string): void {
    inputElement.addEventListener('input', () => {
      let val = inputElement.value.replace(/\D/g, '');
      if (val.length > 14) val = val.substring(0, 14);

      const counterEl = document.getElementById(counterElementId);
      if (counterEl) {
        counterEl.textContent = `${val.length} / 14`;
        if (val.length === 14) {
          counterEl.style.color = '#34d399';
          counterEl.style.background = 'rgba(16, 185, 129, 0.15)';
        } else {
          counterEl.style.color = 'var(--text-dim)';
          counterEl.style.background = 'rgba(255, 255, 255, 0.05)';
        }
      }

      // Group digits: 123 456 789 00012
      let formatted = '';
      for (let i = 0; i < val.length; i++) {
        if (i === 3 || i === 6 || i === 9) formatted += ' ';
        formatted += val[i];
      }
      inputElement.value = formatted;
    });
  }
}
